import React from 'react';
import '../../../static/css/common2.css';
/*import '../../../static/css/menu.css';*/

const TopBoxV2 = React.memo(({ navGrp, navName }) => {
  return (
    <>
      <div className='lodding hide'></div>
    </>
  );
});

export default TopBoxV2;
